module.exports = false;



//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/core-js/modules/_library.js
// module id = 49
// module chunks = 1